<ui-page-container>
  <mat-card class="media-page-content">
    <mat-card-title>
      {{'Documenti archivistici' | translate }}
    </mat-card-title>
    <mat-card-content>
      <ui-table
        [rowSelection]="'checkbox'"
        [fields]="fields"
        [pager]="pager$"
        [filters]="filters$ | async"
        [reload]="reload$"
        [itemsPage]="(page$ | async)?.current"
        [itemsPerPage]="(page$ | async)?.limit"
        [contextMenuActions]="contextMenus"
        (itemsPageChange)="applyChangePageHandler($event)"
        (select)="selectHandler($event)"
        (rowAction)="manageRowActions($event)">
        <div tableActions>
          <app-entity-actions
            className="DocumentoArc"
            [selectedItemsCount]="selectedItems?.length"
            [config]="{ showExport: !!isExportEnable }"
            (export)="exportHandler()"
            (add)="addHandler()"
            (delete)="deleteSelectedHandler()"
            (collectionAdd)="addToCollectionHandler()">
          </app-entity-actions>
        </div>
        <div tableFilters>
          <ui-filters
            [dialogFilters]="MobileFiltersComponent"
            (action)="applyFilterWithDelayHandler($event)">
            <app-source-archivial-filters
              [filters]="filtersObj$ | async"
              #desktopFilter>
            </app-source-archivial-filters>
          </ui-filters>
        </div>
      </ui-table>
    </mat-card-content>
  </mat-card>
</ui-page-container>
